import DeleteWorkingTime from "./DeleteWorkingTime";

export default DeleteWorkingTime;